export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-17.jpg'),
        title: 'INTERNET OF THINGS',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'THE NEW WAVE OF THE IT REVOLUTION',
      description: `<p style="The Internet of Things is regarded as the new wave of the IT revolution after the Internet itself. Experts agree that the industrial value brought by the Internet of Things will be higher than that of the Internet. The Internet of Things will become the next trillion yuan level of information industry business. The Internet of Things is no longer a trend, it is a reality: after years of development, the Internet has been widely used in many aspects. It has laid a solid foundation for the development and leap forward of the Internet of Things. Under the network and intelligent terminal connection, the Internet of Things has become a reality, and it’s getting more and more popular, thus it’s safe to say it will be trending even more in the future.
</p><p>
Design: We have an experienced design team, which can design products to your satisfaction and according to the customer’s requirements. We can provide a full stack of Internet of Things technology solutions ranging from hardware selection to firmware, operating system, middleware and application development.
Development: Our team can provide deep technical capability, research and development of products, 360 degree QA testing, seamless automation, hardware prototype design and conformance testing. Thanks to our professional research and development, all our customers are full of confidence.
After-sales: As a full-service technology provider, we are proud to keep our customers at the forefront of our business. We help customers solve product update iterations through software and hardware updates to ensure that they stay ahead of the competition.
</p>`
    },
    {
      title: 'OUR STRENGTHS',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-17.jpg')+`)"></span>
      <span class="list">
      <i></i>A Strong R&D team<br/>
      <i></i>Rich IT R&D experience<br/>
      <i></i>An efficient platform for operating, tracking, analyzing massive data and providing targeted solutions.<br/>
      <i></i>Excellent software development capabilities and first-class user experience<br/>
      <i></i>Management Team Familiar with the Operational Modes of Various Industries<br/>
      <i></i>Case study:<br/>
      <i></i>Smart Life<br/>
      <i></i>Smart City<br/>
      <i></i>Smart Manufacturing

      </span>`
    }
  ]
}
